import { MediaUpload } from "features/media/media.types"

type Resolver = (value?: string) => void

export class UploadWaitingList {
  private _waitingList: Map<File, Resolver> = new Map()

  startWaiting(file: File): Promise<string> {
    return new Promise((resolve) => {
      this._waitingList.set(file, resolve)
    })
  }

  finishWaiting(file: File, mediaUpload: MediaUpload) {
    const resolver = this._waitingList.get(file)
    if (resolver) {
      resolver(mediaUpload.s3Key)
      this._waitingList.delete(file)
    }
  }
}
